import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  return {
    radioButtons: css`
      display: flex;
      padding: 4px;
      border-radius: 40px;
      border: 1px solid #bbc1ce;
      width: 100%;
      justify-content: space-between;
      text-align: center;
      align-items: center;
    `,
    radioInput: css`
      // Visually hide the native radio input
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;

      ${breakpoints.s} {
        &:focus-visible + label {
          border: 2px solid ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }
    `,
    radioLabel: css`
      padding: 6px 22px;
      border-radius: 40px;
      cursor: pointer;
      transition: background-color 0.3s, color 0.3s;
      flex: 1;
      white-space: nowrap;
      border: 2px solid transparent;
      &:hover {
        border-color: #00539f;
      }
    `,
    radioLabelChecked: css`
      background-color: #00539f;
      span {
        color: white;
      }
    `,
    labelText: css`
      color: #5b6885;
      font-family: 'FS Dillon';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.32px;
    `,
  };
};
